module.exports = require('./backbone-events-standalone');